import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'

console.log('JavaScript is executing...')

const root = document.getElementById('root')
if (root) {
  console.log('Root element found, creating React root...')
  
  try {
    ReactDOM.createRoot(root).render(<App />)
    console.log('React app rendered successfully!')
  } catch (error) {
    console.error('Error rendering App:', error)
    // Fallback to simple working React
    ReactDOM.createRoot(root).render(
      <div className="p-8">
        <h1 className="text-3xl font-bold text-green-600">React is Working!</h1>
        <p className="mt-4">App component failed to render. Error: {error.message}</p>
      </div>
    )
  }
} else {
  console.error('Root element not found!')
  document.body.innerHTML = '<h1 style="color: red;">Error: Root element not found</h1>'
}